import { useEffect } from "react";
import { CATALOG_PRODUCTS } from "../data/products.js";

const ORIGIN = "https://rimmonfarm.com";

// Injects an ItemList of Product structured data so Google can show price /
// availability rich results for the catalog. Removed on unmount.
export default function ProductJsonLd() {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: CATALOG_PRODUCTS.map((p, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "Product",
          name: p.name,
          description: p.desc,
          image: `${ORIGIN}${p.fallback}`,
          category: p.category,
          brand: { "@type": "Brand", name: "Rimmon Farm" },
          // A product sold in several pack sizes advertises the range, so
          // Google shows "₹85 – ₹1,275" instead of one arbitrary size's price.
          offers: p.variants?.length
            ? {
                "@type": "AggregateOffer",
                lowPrice: Math.min(...p.variants.map((v) => v.price)),
                highPrice: Math.max(...p.variants.map((v) => v.price)),
                offerCount: p.variants.length,
                priceCurrency: "INR",
                availability: "https://schema.org/InStock",
                url: `${ORIGIN}/products`,
                seller: { "@type": "Organization", name: "Rimmon Farm" },
              }
            : {
                "@type": "Offer",
                price: p.pricePerKg,
                priceCurrency: "INR",
                availability: "https://schema.org/InStock",
                url: `${ORIGIN}/products`,
                seller: { "@type": "Organization", name: "Rimmon Farm" },
              },
        },
      })),
    };

    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-jsonld", "products");
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
  }, []);

  return null;
}
